import { NavLinkComponent } from './components';
import { NavbarLink } from './presets/navbar-link';

export const NavLink = Object.assign(NavLinkComponent, {
  Navbar: NavbarLink
});
